import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledConfirmButton,
  StyledCancelButton,
} from '../../CountdownTimer/styles'
import { StyledWrapper, StyledTitle, StyledButtonsWrapper } from './styles'

const DeleteReport = ({ onConfirm, onCancel }) => (
  <StyledWrapper>
    <StyledTitle>
      All conversions associated with this report are still unpaid.
      <br />
      Are you sure you want to delete all of them?
    </StyledTitle>
    <StyledButtonsWrapper>
      <StyledCancelButton onClick={onCancel}>Cancel</StyledCancelButton>
      <StyledConfirmButton isReached onClick={onConfirm}>
        Confirm
      </StyledConfirmButton>
    </StyledButtonsWrapper>
  </StyledWrapper>
)

DeleteReport.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default DeleteReport
